import type { ReactNode } from 'react';
import { ScanArt } from './scan-art/ScanArt';

export interface ScanIntroProps {
  title: string;
  lede?: string;
  /** Hide the picture once there is something else to look at (the scanned pages). */
  art?: boolean;
}

/** The scan sheet's top: the scanner-and-computer picture, the one headline, and at most one line under it. */
export function ScanIntro({ title, lede, art = true }: ScanIntroProps): ReactNode {
  return (
    <header className="paige-scan-intro">
      {art && <ScanArt width={260} />}
      <h2 id="paige-intake-title">{title}</h2>
      {lede && <p>{lede}</p>}
    </header>
  );
}
